import {
  GET_SUBSCRIPTION_PRICES,
  globalConstants,
  CREATE_FREELANCE_INSTRUCTOR,
} from "../constants";
import { getRequest, postRequest, putRequest } from "../system/server-call";
import responseHandler from "../system/server-response-handler";

const getSubscriptionPrices = () => {
  return getRequest(
    `/${globalConstants.VERSION}/${GET_SUBSCRIPTION_PRICES}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const updateSubscriptionPrices = (data) => {
  return putRequest(
    `/${globalConstants.VERSION}/${GET_SUBSCRIPTION_PRICES}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

async function proceedPayment(data) {
  return postRequest(
    `/${globalConstants.VERSION}/${CREATE_FREELANCE_INSTRUCTOR}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const subscriptionService = {
  getSubscriptionPrices,
  proceedPayment,
  updateSubscriptionPrices,
};
